import {AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn} from '@angular/forms';
import {map} from "rxjs/operators";

const emailDomains = [
  'com', 'org', 'net', 'edu', 'gov', 'mil', 'info', 'biz', 'name', 'pro',
  'aero', 'coop', 'museum', 'jobs', 'mobi', 'travel', 'asia',
  'cat', 'tel', 'cloud', 'tech', 'app', 'dev', 'shop', 'blog', 'design',
  'art', 'online', 'site', 'store', 'xyz', 'media',

  'fr', 'uk', 'us', 'de', 'ca', 'au', 'jp', 'cn', 'ru', 'br', 'in', 'es',
  'it', 'mx', 'ch', 'nl', 'se', 'no', 'dk', 'pl', 'be',
  'it', 'at', 'fi', 'gr', 'hu', 'ie', 'il', 'pt', 'za',
  'hk', 'sg', 'tw', 'ae', 'sa', 'kr', 'my', 'vn', 'ph',
  'nz', 'bg', 'ro', 'sk', 'hr', 'si', 'lt', 'lv', 'ee',
  'is', 'mt', 'cy', 'bg', 'kz', 'ua', 'by', 'am', 'ge',
  'rs', 'ba', 'me', 'mk', 'md', 'ee', 'vn', 'kh', 'bn',
  'np', 'lk', 'bd', 'pk', 'bd', 'tt', 'tt', 'us', 'us'
];

export function emailDomainValidator(): AsyncValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | any => {
    const email = control.value;

    if (!email) {
      return { invalidDomain: true };
    }
    const domainMatch = email.match(/@([a-z0-9.-]+)\.([a-z]{2,})$/);
    if (!domainMatch) {
      return { invalidDomain: true };
    }
    const domainExtension = domainMatch[2];
    if (emailDomains.includes(domainExtension)) {
      return null;
    } else {
      return { invalidDomain: true };
    }
  };
}
